"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.list.title': 'Profesiones',
    'profession.list.empty': 'No se encontraron profesiones',
};
